import { Stack, Text, } from "@chakra-ui/react";
import APCommonDialog from "./APCommonDialog";
import React from "react";
import { TranslationsId, useVocabIntl } from "../../hooks/useVocabTranslation";

interface CancelConfirmModalProps {
  onConfirm: (name: string, levels: string[]) => void;
  open: boolean;
  onClose: () => void;
  title: TranslationsId | React.ReactNode;
  description: TranslationsId;
  btnTitle?: TranslationsId;
}

export default function CancelConfirmModal({
                                             onConfirm,
                                             open,
                                             onClose,
                                             title,
                                             description,
                                             btnTitle = "quit-button"
                                           }: CancelConfirmModalProps) {
  const { getFormattedString, APFormattedMessage } = useVocabIntl()

  if (typeof (title) === "string") {
    title = <APFormattedMessage id={title as TranslationsId} />
  }

  let formattedDescription: string = getFormattedString(description);

  let formattedBtnTitle: string = getFormattedString(btnTitle);

  return (
    <APCommonDialog
      open={open}
      title={title}
      onNext={onConfirm}
      onClose={onClose}
      error
      btnTitle={formattedBtnTitle}
    >
      <Stack>
        <Text>{formattedDescription}</Text>
      </Stack>
    </APCommonDialog>
  );
}
